import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs';

import { PrivaNotificationComponent } from '@priva/components/notification';
import { PrivaLocalizationModule } from '@priva/localization';

import { AppWizardStepComponent } from 'app/features/setup-wizard/components';
import { LoadMasterDataComponent } from 'app/shared/components';
import { selectIsMasterDataLoaded } from 'app/state/master-data/master-data.selectors';

import { AppWizardStep } from '../../../components';

@Component({
    selector: 'app-load-master-data-wizard-step',
    templateUrl: './load-master-data-wizard-step.component.html',
    imports: [
        AsyncPipe,
        PrivaLocalizationModule,
        PrivaNotificationComponent,
        AppWizardStepComponent,
        LoadMasterDataComponent,
    ],
})
export class LoadMasterDataWizardStepComponent extends AppWizardStep {
    private destroyRef = inject(DestroyRef);

    constructor(store: Store) {
        super();
        super.setTitle('SETUP.STEP_4.TITLE');
        this.canGoNext$.next(false);
        store
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                select(selectIsMasterDataLoaded),
                filter((isMasterDataLoaded) => isMasterDataLoaded),
            )
            .subscribe(() => {
                this.onMasterDataLoaded();
            });
    }

    onMasterDataLoaded(): void {
        this.canGoNext$.next(true);
    }
}
